import React from "react";
import "../styles/Price.css";

const Price = () => {
  return (
    <section id="prices">
      <div className="price-header">
        <h2>Price List</h2>
        <p>We offer competitive rates for driving lessons</p>
      </div>

      <div className="price-grid">
        {/* <div className="price-item">
          <h3 className="red-special">Special Offer</h3>
          <p className="price">£70</p>
          <br />
          <p className="duration">First Lesson: 2 Hours</p>
        </div> */}

        <div className="price-item">
          <h3>2 Hour Lesson</h3>
          <p className="price">£80</p>
          <br />
          <p className="duration"></p>
        </div>

        <div className="price-item">
          <h3>10 Hour Block Lesson</h3>
          <p className="price">£390</p>
          <br />
          <ul className="package-list">
            <li></li>
          </ul>
        </div>

        <div className="price-item">
          <h3>Refresher Lesson</h3>
          <p className="price">£90</p>
          <br />
          <ul className="package-list">
            <li>2 Hour Lesson</li>
          </ul>
        </div>

        <div className="price-item">
          <h3>Motorway Lesson</h3>
          <p className="price">£135</p>
          <br />
          <ul className="package-list">
            <li>3 Hour Motorway Lesson</li>
          </ul>
        </div>

        <div className="price-item">
          <h3>Pass Plus</h3>
          <p className="price">£270</p>
          <br />
          <ul className="package-list">
            <li>6 Hours</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Price;
